import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const KpiCard = styled.div`
	width: 50%;
	padding: 1em;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	margin: ${props => (props.isLeft ? '0 0.5% 0 0' : '0 0 0 0.5%')};
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-evenly;
	align-items: center;
	text-align: center;
`;

export const CardValue = styled.div`
	display: block;
	font-size: 150%;
	font-weight: bolder;
`;

export const CardText = styled.div`
	display: block;
	font-size: 70%;
	padding-left: 0.2em;
`;
